"use strict";
// (C) 2021-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteDashboardHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var general_1 = require("../../events/general");
var sdk_model_1 = require("@gooddata/sdk-model");
var redux_batched_actions_1 = require("redux-batched-actions");
var executionResults_1 = require("../../store/executionResults");
var configSelectors_1 = require("../../store/config/configSelectors");
var metaSelectors_1 = require("../../store/meta/metaSelectors");
var dashboard_1 = require("../../events/dashboard");
var ts_invariant_1 = require("ts-invariant");
var stateInitializers_1 = require("./common/stateInitializers");
function deleteDashboard(ctx, dashboardRef) {
    var backend = ctx.backend, workspace = ctx.workspace;
    return backend.workspace(workspace).dashboards().deleteDashboard(dashboardRef);
}
/**
 * Resets the essential state so that an empty dashboard is rendered. This includes change of the
 * saga context so that it contains an empty dashboardRef.
 *
 * Note: This will not clear any of the dashboard-agnostic global state such as config and settings.
 */
function resetToNewDashboard(ctx) {
    var dateFilterConfig;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(configSelectors_1.selectDateFilterConfig)];
            case 1:
                dateFilterConfig = _a.sent();
                return [4 /*yield*/, effects_1.put(redux_batched_actions_1.batchActions(tslib_1.__spread(stateInitializers_1.actionsToInitializeNewDashboard(dateFilterConfig), [
                        executionResults_1.executionResultsActions.clearAllExecutionResults(),
                    ]), "@@GDC.DASH/BATCH.CLEAR"))];
            case 2:
                _a.sent();
                /*
                 * We must do this by mutating the context object, the setContext effect changes the context only
                 * for the current saga and its children. See https://github.com/redux-saga/redux-saga/issues/1798#issuecomment-468054586
                 */
                ctx.dashboardRef = undefined;
                return [2 /*return*/];
        }
    });
}
function deleteDashboardHandler(ctx, cmd) {
    var existingDashboardRef, persistedDashboard;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                existingDashboardRef = ctx.dashboardRef;
                return [4 /*yield*/, effects_1.select(metaSelectors_1.selectPersistedDashboard)];
            case 1:
                persistedDashboard = _a.sent();
                if (!persistedDashboard) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Attempting to delete a dashboard that was never saved.");
                }
                // if this invariant fails, it means the state is inconsistent; previous command processing must have done
                // something wrong; for instance updated context with some ref but did not update the persisted dashboard
                // accordingly
                ts_invariant_1.invariant(existingDashboardRef &&
                    (sdk_model_1.areObjRefsEqual(existingDashboardRef, sdk_model_1.uriRef(persistedDashboard.uri)) ||
                        sdk_model_1.areObjRefsEqual(existingDashboardRef, sdk_model_1.idRef(persistedDashboard.identifier))));
                // perform the actual delete
                return [4 /*yield*/, effects_1.call(deleteDashboard, ctx, persistedDashboard.ref)];
            case 2:
                // perform the actual delete
                _a.sent();
                return [4 /*yield*/, effects_1.call(resetToNewDashboard, ctx)];
            case 3:
                _a.sent();
                return [2 /*return*/, dashboard_1.dashboardDeleted(ctx, persistedDashboard, cmd.correlationId)];
        }
    });
}
exports.deleteDashboardHandler = deleteDashboardHandler;
//# sourceMappingURL=deleteDashboardHandler.js.map